import { render, staticRenderFns } from "./x-checkbox.vue?vue&type=template&id=70623fde&scoped=true&"
import script from "./x-checkbox.vue?vue&type=script&lang=js&"
export * from "./x-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./x-checkbox.vue?vue&type=style&index=0&id=70623fde&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70623fde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('70623fde', component.options)
    } else {
      api.reload('70623fde', component.options)
    }
    module.hot.accept("./x-checkbox.vue?vue&type=template&id=70623fde&scoped=true&", function () {
      api.rerender('70623fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-checkbox.vue"
export default component.exports